// extracted by mini-css-extract-plugin
export default {"buttonClass":"Button_buttonClass__X0Xxp","buttonDisabled":"Button_buttonDisabled__IA-Qj"};